import { mapGetters, mapActions } from 'vuex'
const EventBus = window.VueEventBus

export default {
  name: 're-login-status',
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: ''
    },
    signInLabel: {
      type: String,
      default: 'Sign in'
    },
    signInClass: {
      type: [String, Array, Object],
      default: 're-status-sign-in-link'
    },
    SignInLink: {
      type: [String, Object],
      default: () => ({ name: 'sign-in' })
    },
    signOutLabel: {
      type: String,
      default: 'Sign out'
    },
    signOutClass: {
      type: [String, Array, Object],
      default: 're-status-sign-out-link'
    },
    noSignOutLink: {
      type: Boolean,
      default: false
    },
    profileLabel: {
      type: String,
      default: 'My Account'
    },
    profileClass: {
      type: [String, Array, Object],
      default: 're-status-profile-link'
    },
    profileLink: {
      type: [String, Object],
      default: () => ({ name: 'user.profile' })
    },
    noProfileLink: {
      type: Boolean,
      default: false
    },
    reloadAfterSignOut: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      routeIsProfile: false,
    }
  },

  created() {
    const routeName = this.$route.name
    this.routeIsProfile = routeName === 'user.profile'
  },
  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck',
    }),
    showSignInLink() {
      return !this.authenticated || !this.user || !this.user.verified
    },
    showProfileLink() {
      return !this.showSignInLink && !this.routeIsProfile && !this.noProfileLink
    },
    showSignOutLink() {
      return !this.showSignInLink && !this.noSignOutLink
    }
  },
  methods: {
    ...mapActions(['logout']),

    async userSignOut() {
      await this.logout()
      if (this.reloadAfterSignOut) {
        window.location.reload()
      }
    }
  }
}
